$(window).load(function(){
	$(".top-article-title").textOverflowEllipsis({
		resize: true, // ウィンドウリサイズ時に追従するか
		numOfCharactersToReduce : 1, // 高さ計算するときに削る文字数
		numOfLine : 2, //行数
		suffix: '...' // 省略記号
	});																								
})